/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuerUmsatz
 */
export interface FuerUmsatz {
    /**
     * 
     * @type {number}
     * @memberof FuerUmsatz
     */
    umsatzId: number;
}

/**
 * Check if a given object implements the FuerUmsatz interface.
 */
export function instanceOfFuerUmsatz(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "umsatzId" in value;

    return isInstance;
}

export function FuerUmsatzFromJSON(json: any): FuerUmsatz {
    return FuerUmsatzFromJSONTyped(json, false);
}

export function FuerUmsatzFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuerUmsatz {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'umsatzId': json['umsatzId'],
    };
}

export function FuerUmsatzToJSON(value?: FuerUmsatz | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'umsatzId': value.umsatzId,
    };
}

